// extracted by mini-css-extract-plugin
module.exports = {"question":"TimeSection_question__lxFCs","graph":"TimeSection_graph__5vtq5"};